<template>
  <main-layout wide>
    <GroupsListContainer />
  </main-layout>
</template>

<script>
import GroupsListContainer from '@/components/Widgets/GroupsListContainer';

export default {
  name: 'AssociateGroups',
  components: {
    GroupsListContainer,
  },
};
</script>

<style lang="scss" scoped>
</style>
